import axios from "axios";
import { notificationActionTypes } from "./notificationTypes";
import baseUrl from "../../config/api";

export const getAllNotificationsStart = () => ({
  type: notificationActionTypes.GET_ALL_NOTIFICATIONS_START
});

export const getAllNotificationsSuccess = (notifications) => ({
  type: notificationActionTypes.GET_ALL_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const getAllNotificationsFailure = (error) => ({
  type: notificationActionTypes.GET_ALL_NOTIFICATIONS_FAILURE,
  payload: error,
});

export const deleteNotificationStart = () => ({
  type: notificationActionTypes.DELETE_NOTIFICATION_START,
});

export const deleteNotificationSuccess = (success, notificationId) => ({
  type: notificationActionTypes.DELETE_NOTIFICATION_SUCCESS,
  payload: {
    success,
    notificationId,
  },
});

export const deleteNotificationFailure = (error) => ({
  type: notificationActionTypes.DELETE_NOTIFICATION_FAILURE,
  payload: error,
});
export const deleteAllNotificationsStart=()=>({
  type: notificationActionTypes.DELETE_ALL_NOTIFICATIONS_START,
})
export const deleteAllNotificationsSuccess = (success) => ({
  type: notificationActionTypes.DELETE_ALL_NOTIFICATIONS_SUCCESS,
  payload:success,
});

export const deleteAllNotificationsFailure = (error) => ({
  type: notificationActionTypes.DELETE_ALL_NOTIFICATIONS_FAILURE,
  payload:error,
});
export const addNotification=(notification)=>({
  type:notificationActionTypes.ADD_NOTIFICATION,
  payload:notification
})
export const toggleNotificationBar=()=>({
  type:notificationActionTypes.TOGGLE_NOTIFICATION_BAR,
})
export const getAllNotifications = (userId, token) => async (dispatch) => {
    dispatch(getAllNotificationsStart());
    try {
      const response = await axios.get(
        `${baseUrl}/trackAPI/notifications/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      dispatch(getAllNotificationsSuccess(response.data));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to fetch notifications.";
      dispatch(getAllNotificationsFailure(errorMsg));
    }
  };

  export const deleteNotification =
  (userId, notificationId, token) => async (dispatch) => {
    dispatch(deleteNotificationStart());
    try {
      const response = await axios.delete(
        `${baseUrl}/trackAPI/notifications/${userId}/${notificationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(deleteNotificationSuccess(response.data, notificationId));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to delete notification.";
      dispatch(deleteNotificationFailure(errorMsg));
    }
  };
  export const deleteAllNotifications =
  (userId, token) => async (dispatch) => {
    dispatch(deleteAllNotificationsStart());
    try {
      const response = await axios.delete(
        `${baseUrl}/trackAPI/notifications/${userId}/deleteAll`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(deleteAllNotificationsSuccess(response.data));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to delete notifications.";
      dispatch(deleteNotificationFailure(errorMsg));
    }
  };